define([], function() {
  'use strict';
  return {
    assets: {
      image: '/v1.0/Tag/{tag_id}/images/{platform}/{status}{resolution}.png',
      audio: '/v1.0/Tag/{tag_id}/audio/{tag_id}.mp3'
    }
  };
});
